import { constantCase } from "change-case";
import statuses from "statuses";
function getStatusConstant(status) {
    return status === 200 ? "SUCCESS" : constantCase(String(statuses(status)));
}
export class Exception extends Error {
    /**
     * Exception base name
     * @type {string}
     */
    name = "HTTP_EXCEPTION";
    /**
     * Message of the exception
     */
    message;
    /**
     * Exception type
     * @type {string}
     */
    type = "HTTP_EXCEPTION";
    /**
     * Stack calling
     */
    stack;
    origin;
    /**
     * HTTP Code Status
     */
    status;
    /**
     *
     */
    body;
    /**
     * Headers must be sent to the response
     */
    headers = {};
    constructor(status = 500, message = "", origin) {
        super(message);
        this.status = status;
        this.message = message;
        this.name = getStatusConstant(status);
        this.setOrigin(origin);
    }
    setHeaders(headers) {
        this.headers = {
            ...this.headers,
            ...headers
        };
        return this;
    }
    setHeader(key, value) {
        this.headers[key] = value;
        return this;
    }
    setOrigin(origin) {
        if (origin) {
            if (origin instanceof Error) {
                this.origin = origin;
                this.message = `${this.message}, innerException: ${this.origin.message}`.trim();
            }
            else if (typeof origin === "string") {
                this.origin = new Error(origin);
                this.message = `${this.message}, innerException: ${this.origin.message}`.trim();
            }
            else {
                this.body = origin;
            }
        }
    }
    toString() {
        return `${this.name}(${this.status}): ${this.message} `.trim();
    }
}
export class HTTPException extends Exception {
}
//# sourceMappingURL=Exception.js.map